import {helpdeskQueries} from '@app/dashboard/helpdesk-queries';
import {AuthRoute} from '@common/auth/guards/auth-route';
import {shouldRevalidateDatatableLoader} from '@common/datatable/filters/utils/should-revalidate-datatable-loader';
import {queryClient} from '@common/http/query-client';
import {searchParamsFromUrl} from '@ui/utils/urls/search-params-from-url';
import {RouteObject} from 'react-router';

/**
 * Assuntos de abertura de chamado — tela própria em `/admin/ticket-subjects`.
 *
 * Não fica sob Equipe: aquela seção é sobre pessoas (membros, grupos,
 * convites), e assunto é configuração de roteamento. Espelha `views`, que é a
 * tela irmã em natureza.
 *
 * O guard usa a MESMA permissão que o controller — as duas pontas precisam
 * concordar, senão a tela abre e a API recusa.
 */
export const ticketSubjectsRoutes: RouteObject[] = [
  {
    path: 'ticket-subjects',
    element: <AuthRoute permission="ticket_subjects.manage" />,
    children: [
      {
        index: true,
        shouldRevalidate: shouldRevalidateDatatableLoader,
        lazy: () =>
          import('@app/dashboard/ticket-subjects/ticket-subjects-index-page'),
        loader: ({request}) =>
          queryClient.ensureQueryData(
            helpdeskQueries.ticketSubjects.index(
              searchParamsFromUrl(request.url),
            ),
          ),
      },
      {
        path: 'new',
        lazy: () =>
          import('@app/dashboard/ticket-subjects/create-ticket-subject-page'),
      },
      {
        path: ':subjectId/edit',
        lazy: () =>
          import('@app/dashboard/ticket-subjects/edit-ticket-subject-page'),
        loader: ({params}) =>
          queryClient.ensureQueryData(
            helpdeskQueries.ticketSubjects.get(params.subjectId!),
          ),
      },
    ],
  },
];
